export default import.meta.ROLLDOWN_FILE_URL_cZzk8$Te0IxbKasGatFCWg